<template>
  <div>
    <loading :active.sync="loader" :can-cancel="false" :is-full-page="true"></loading>
      <b-row>
        <b-col cols="12" class="d-flex justify-content-center">
          <div style="width: 23%">
            <b-col cols="12" class="mb-3" style="text-align: left">
              <span class="textForm">Guarda<span style="color: red">*</span></span>
            </b-col>
            <b-col class="d-flex justify-content-between">
              <b-form-radio v-model="selected" name="acetato" value="1" @change="reset()">Acetato</b-form-radio>
              <b-form-radio v-model="selected" name="acrilico" value="2" @change="reset()">Acrilico</b-form-radio>
            </b-col>

            <!-- Si es Acetato -->
            <div v-if="selected === '1'" class="mt-4">
              <b-col cols="12" class="mb-3" style="text-align: left">
                <div class="mb-2">
                  <span class="textForm">Tipo de recorte<span style="color: red">*</span></span>
                  <v-select :clearable="false" :options="listaTiposRecorte"
                            v-model="form.idTipoRecorte" :reduce="(variable) => variable.idTipoRecorte" label="descripcion"
                            @click.native.stop.prevent class="opcion-menu"
                            required
                            placeholder="Selecciona una opción">
                  </v-select>
                </div>

                <div class="mb-2">
                  <span class="textForm">Calibre<span style="color: red">*</span></span>
                  <v-select :clearable="false" :options="listaTiposCalibre"
                            v-model="form.idTipoCalibre" :reduce="(variable) => variable.idTipoCalibre" label="descripcion"
                            @click.native.stop.prevent class="opcion-menu"
                            required
                            placeholder="Selecciona una opción">
                  </v-select>
                </div>
                <div class="mb-2">
                  <span class="textForm">Observaciones<span style="color: red">*</span></span>
                  <b-form-textarea style="resize:both;" v-model="form.observaciones" rows="1" placeholder="Ingrese las observaciones"></b-form-textarea>
                </div>
              </b-col>
            </div>

            <!-- Si es Acrílico -->
            <div v-if="selected === '2'" class="mt-4">
              <b-col cols="12" class="mb-3" style="text-align: left">
                <div class="mb-2">
                  <span class="textForm">Tipo de Acrilico<span style="color: red">*</span></span>
                  <v-select :clearable="false" :options="listaTiposAcrilico"
                            v-model="form.idTipoAcrilico" :reduce="(variable) => variable.idTipoAcrilico" label="descripcion"
                            @click.native.stop.prevent class="opcion-menu"
                            required
                            placeholder="Selecciona una opción">
                  </v-select>
                </div>
                <div class="mb-2">
                  <span class="textForm">Observaciones<span style="color: red">*</span></span>
                  <b-form-textarea style="resize:both;"
                                   v-model="form.observaciones" rows="1" placeholder="Ingrese las observaciones"
                  ></b-form-textarea>
                </div>
              </b-col>
            </div>

            <div class="text-center mt-4">
              <b-button style="background: #1B81AF" variant="primary" pill size="sm" @click="finalizarOdt()"
              :disabled="(selected === '1' && form.idTipoCalibre == null && form.idTipoRecorte == null) ||
                         (selected === '2' && form.idTipoAcrilico == null) ||
                         (form.observaciones == null || form.observaciones == '' )|| loader">
                <span>Finalizar</span>
                <b-spinner v-if="loader" variant="light" label="spinner" small></b-spinner>
              </b-button>
            </div>
          </div>
        </b-col>
      </b-row>

  </div>
</template>

<script>
export default {
  name: "Guarda",
  props: {
    listaTiposAcrilico: Array,
    listaTiposRecorte: Array,
    listaTiposCalibre: Array,
    tipoFlujoFisico: Number,
    loader: Boolean,
  },
  data: () => {
    return {
      selected: '', // 1 para acetato, 2 para acrílico
      form: {
        idTipoRecorte: null,
        idTipoCalibre: null,
        observaciones: null,
        idTipoAcrilico: null,
        tipoFlujoFisico: null,
      },
      tiposRecorte: [],
      tiposAcrilico: [],
      tiposCalibre: [],
    }
  },
  created () {
    this.form.tipoFlujoFisico = this.tipoFlujoFisico;
  },
  methods: {
    finalizarOdt() {
      this.$emit("finalizar", this.form);
    },

    reset() {
      this.form = {
        idTipoRecorte: null,
        idTipoCalibre: null,
        observaciones: null,
        idTipoAcrilico: null,
        tipoFlujoFisico: this.tipoFlujoFisico,
      }
    }

  },

}
</script>

<style scoped>
.title_seccion_odt{
  font-family: 'Gilroy', sans-serif !important;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #60ADDC;
}

.textForm {
  font-size: 10px;
  text-align: left;
}
</style>
